

export const API_URL = "https://api.cms.lions306d9.org/";

//export const API_URL = "http://localhost:8080/";

//export default API_URL;